var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"6"}},[_c('avatar',{attrs:{"initialWidth":_vm.avatarWidth}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('menuMatrix')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }